<template>
  <b-card class="custom-card white-bg">
    <div :id="downloadId" class="container-line-chart">
      <b-card-header class="">
        <div class="card-text-strong">
          <span class="card-management-title">{{ titleChart }}</span>
          <slot name="header"></slot>
        </div>
        <slot name="subheader"></slot>
      </b-card-header>
      <b-card-body>
        <div style="width: 100%">
          <slot name="body" style="width: 100%"></slot>
        </div>
      </b-card-body>
      <div class="remove-elem-download text-right">
        <span class="pr-10" v-if="downloadShow">
          <img src="static/img/download-graphs.png" class="download_graph cursor_pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Download" />
          <div class="dropdown-menu download-dropdown-box p-0">
            <span
              class="
                dropdown-item
                download-dropdown-item
                border-bottom
                cursor_pointer
              "
              @click="downloadCSVGraphs()"
              ><img src="/static/img/csv.svg" class="mr-6" />CSV</span
            >
            <span
              class="
                dropdown-item
                download-dropdown-item
                border-bottom
                cursor_pointer
              "
              @click="downloadPDFGraphs()"
              ><img src="/static/img/pdf.svg" class="mr-6" />PDF</span
            >
            <span
              class="
                dropdown-item
                download-dropdown-item
                border-bottom
                cursor_pointer
              "
              @click="downloadPNGGraphs()"
              ><img src="/static/img/img.svg" class="mr-6" />PNG</span
            >
          </div>
        </span>

        <span @click="zoomGraph(true)" class="cursor_pointer pr-20" title="Expand" v-if="isZoomEnabled && !zoomGraphValueChild && downloadShow">
          <img src="/static/img/expandbox.svg" class="download_graph" />
        </span>
        <span @click="zoomGraph(false)" class="cursor_pointer pr-20" v-if="isZoomEnabled && zoomGraphValueChild && downloadShow" title="Collapse">
          <img src="/static/img/unexpand.svg" class="download_graph" />
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { getSiteID } from "../../services/visualization/data-management";

export default {
  props: {
    downloadId: { type: String, default: "" },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    specificSiteId: [Object, Array],
    onCSVDownload: { type: Function, default: null },
    onPNGDownload: { type: Function, default: null },
    onPDFDownload: { type: Function, default: null },
    isZoomEnabled: { type: Boolean, default: true },
    downloadShow: { type: Boolean, default: false }
  },
  data() {
    return {
      type: "line",
      dataFormat: "json",
      renderAt: "chart-container",
      width: "100%",
      height: "250",
      zoomGraphValueChild: "",
      getSiteID
    };
  },

  watch: {
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    }
  },
  methods: {
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    downloadPNGGraphs() {
      if (this.onPNGDownload) {
        this.$emit("onPNGDownload");
        return;
      }
      this.download("png");
    },
    downloadPDFGraphs() {
      if (this.onPDFDownload) {
        this.$emit("onPDFDownload");
        return;
      }

      this.download("pdf");
    },
    download(type) {
      const todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      const container = document.querySelector("#" + this.downloadId);
      let filename = this.titleChart + "_" + todayDate + "." + type;
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        filename = this.titleChart + "_" + todayDate + "_" + getSiteID(this.specificSiteId[0]) + "." + type;
      }
      html2canvas(container, {
        allowTaint: true,
        logging: false,
        height: !this.zoomGraphValueChild ? 400 : 550,
        scrollY: -window.scrollY,
        useCORS: true,
        scrollX: -window.scrollX,
        onclone: document => {
          if (this.specificSiteId && this.specificSiteId.length > 0) {
            if (document.querySelector("#" + this.downloadId + " .title-date") != null) {
              document.querySelector("#" + this.downloadId + " .title-date").append("_" + this.getSiteID(this.specificSiteId[0]));
            } else {
              document.querySelector("#" + this.downloadId + " .card-management-title").append("_" + this.getSiteID(this.specificSiteId[0]));
            }
          }
          document.querySelectorAll("#" + this.downloadId + " .custom-tooltip").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .apexcharts-toolbar").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .remove-elem-download").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .remove-zoom-icons").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .nav-item").forEach(element => {
            const ele = element.querySelector(".nav-link.active");
            if (!ele) {
              element.remove();
            }
          });

          if (this.downloadId === "studyMaps") {
            const dateTime = document.createElement("div");
            dateTime.classList.add("ml-15");
            dateTime.textContent = todayDate;
            document.querySelector("#" + this.downloadId).append(dateTime);
          } else {
            if (this.downloadId === "completion-data") {
              const dateTime = document.createElement("div");
              dateTime.classList.add("ml-15");
              dateTime.textContent = todayDate;
              document.querySelector("#" + this.downloadId).append(dateTime);
              if (document.querySelectorAll(".table-content").length > 0) {
                document.querySelectorAll(".table-content")[0].className = "remove-overflow";
              }
              if (document.querySelectorAll(".rtl-display").length > 0) {
                document.querySelectorAll(".rtl-display")[0].className = "ltr-display";
              }
            } else if (this.downloadId === "daily-sensor-compliance") {
              const dateTime = document.createElement("div");
              dateTime.classList.add("ml-15");
              dateTime.textContent = todayDate;
              document.querySelector("#" + this.downloadId).append(dateTime);
            } else {
              document.querySelector("#" + this.downloadId).innerHTML += '<div class="ml-15">' + todayDate + "</div>";
            }
          }
        }
      }).then(canvas => {
        if (type === "pdf") {
          const imgData = canvas.toDataURL("image/jpeg");
          const pdf = new jspdf("p", "mm", "a4");
          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight, "", "FAST");
          pdf.save(filename);
        } else if (type === "png") {
          const link = document.createElement("a");
          document.body.appendChild(link);
          link.download = filename;
          link.href = canvas.toDataURL("image/png");
          link.target = "_blank";
          link.click();
        }
      });
    },
    downloadCSVGraphs() {
      this.$emit("onCSVDownload"); //
    }
  }
};
</script>
<style lang="scss" scoped>
#app,
.container-line-chart {
  width: 100%;
}

#expected-data,
#recent-data {
  .card-body {
    padding: 0px !important;
  }
}

.fa-info-circle:before {
  content: "\F05A";
  color: #868686;
}

.custom-card .card-body:first-of-type #daily-spirometer-reading {
  .card-header div {
    overflow: visible !important;
  }

  .card-body {
    display: block !important;
  }
}

.analytics-custom .tooltip .tooltip-inner {
  color: #2d3752 !important;
  max-width: 270px !important;
  text-align: left !important;
  flex-grow: 0 !important;
  // box-shadow: 0 4px 10px 0 rgb(0 0 0 / 25%) !important;
  border: solid 1px #b0bac9 !important;
  background-color: #eff3f5 !important;
}
.analytics-custom .tooltip.bs-tooltip-right .arrow::before {
  flex-grow: 0 !important;
  // box-shadow: 0 4px 10px 0 rgb(0 0 0 / 25%) !important;
  border: solid 1px #b0bac9 !important;
  background-color: #eff3f5 !important;
}
</style>
